export const API_URL = process.env.NODE_ENV === "production"
    ? "https://khorjak.pythonanywhere.com/api/v2/"
    : "http://127.0.0.1:5000/api/v2/";
export const TRANSBYBILL_LIMIT = 10;
